export enum ReducedAssetClass {
    Index = "Index",
    Commodity = "Commodity",
    ExchangeRate = "ExchangeRate",
    Share = "Share",
    ETF = "ETF",
    Fund = "Fund",
}

export enum AssetClass {
    Index = "Index",
    Commodity = "Commodity",
    ExchangeRate = "ExchangeRate",
    Share = "Share",
    ETF = "ETF",
    Fund = "Fund",

    // Not used
    InterestRate = "InterestRate",
    Derivative = "Derivative",
    Unknown = "Unknown"
}
